import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getVisibleCatalogs, getFilters, getPagination, getIsLoading } from 'catalogs/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as Catalogs from 'catalogs/components';
import CatalogRowContainer from 'catalogs/containers/CatalogRowContainer';
import CatalogsListHandlers from 'catalogs/containers/CatalogsListHandlers';
import { toggle } from 'catalogs/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class CatalogsListContainer extends Component {
  renderRows = () =>
    this.props.catalogs.map((catalog) => (
      <CatalogRowContainer key={catalog.id} catalog={catalog} handleToggle={this.handleToggle} />
    ));

  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  render = () => (
    <CatalogsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Catalogs.ListView
          count={this.props.catalogs.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Catalogs.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  catalogs: getVisibleCatalogs(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(CatalogsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/containers/CatalogsListContainer.js